import { ExternalDocSearchInfo, ExternalDocument } from 'estensa-module';
import { ExternalDocPatientInfo } from '../../models/vnext.models';

export interface ExternalDocsState {
    info: ExternalDocSearchInfo;
    patientInfo: ExternalDocPatientInfo;
    examinationsInfo: string[],
    selectedDoc?: ExternalDocument;
    isClosed?: boolean;
}


export const externalDocsInitialState: ExternalDocsState = {
    info: null,
    patientInfo: null,
    examinationsInfo: null,
    selectedDoc: null,
    isClosed: false
};
